import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import styles from './PricingSection.module.css';

const PricingSection = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = React.useState(false);
  const sectionRef = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleButtonClick = (plan) => {
    if (isAuthenticated) {
      navigate('/settings', { state: { fromPricing: true }});
    } else {
      navigate(`/signup?plan=${plan}`);
    }
  };

  return (
    <div className={styles.pricingContainer} ref={sectionRef}>
      <h2 className={styles.pricingTitle}>Choose the right plan for you</h2>
      <div className={styles.pricingCards}>
        <div className={`${styles.pricingCard} ${styles.basic} ${isVisible ? styles.animate : ''}`}>
          <h3>Monthly Plan</h3>
          <div className={styles.price}>$50.00</div>
          <div className={styles.perks}>
            <p>✓ Discord Access</p>
            <p>✓ Betslips & tips bot</p>
            <p>✓ Conversion Wizard bot</p>
            <p>✓ Mug Master bot</p>
            <p>✓ Arbitrage & Value bot</p>
            <p>✓ Bookie Database access</p>
            <p>✓ Education on Matched Betting</p>
            <p>✓ Betting Calculators</p>
            <p>✓ Basic support</p>
          </div>
          <button 
            onClick={() => handleButtonClick('monthly')} 
            className={styles.pricingButton}
          >
            Join
          </button>
        </div>
        <div className={`${styles.pricingCard} ${styles.premium} ${isVisible ? styles.animate : ''}`}>
          <div className={styles.popularBadge}>20% Off!</div>
          <h3>Quarterly Plan</h3>
          <div className={styles.price}>$120.00</div>
          <div className={styles.perks}>
            <p>✓ Discord Access</p>
            <p>✓ Betslips & tips bot</p>
            <p>✓ Conversion Wizard bot</p>
            <p>✓ Mug Master bot</p>
            <p>✓ Arbitrage & Value bot</p>
            <p>✓ Bookie Database access</p>
            <p>✓ Education on Matched Betting</p>
            <p>✓ Betting Calculators</p>
            <p>✓ Priority support</p>
          </div>
          <button 
            onClick={() => handleButtonClick('quarterly')} 
            className={styles.pricingButton}
          >
            Join
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingSection;